import { axios } from "@/libraries/axios";
import type { ParamsGetMpisMembersSchema } from "@/schemas";
import type { ContactMemberResponse } from "@/types";
import type { AxiosRequestConfig } from "axios";

class MpisService {
	async getMembers(
		params?: ParamsGetMpisMembersSchema,
		config?: AxiosRequestConfig,
	) {
		try {
			const res = await axios.get<ContactMemberResponse>(
				"/api/v1/mpis/members",
				{
					...config,
					params: {
						...params,
						...config?.params,
						limit: params?.limit ?? 25,
					},
				},
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
}

export const mpisService = Object.freeze(new MpisService());
